import React, { FC, useState } from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import { RootState } from 'redux/reducers';

import AtRiskIcon from 'assets/at-risk.png';
import AttendanceRedIcon from 'assets/attendance-red.png';
import AttendanceSolidIcon from 'assets/attendance-solid.png';
import { ReactComponent as ChevronRightIcon } from 'assets/chevron_right.svg';
import CoursesIcon from 'assets/courses.png';

import StudentAnalyticsDetails from './StudentAnalyticsDetails';

interface StudentAnalyticsTableProps {
  showEnrolledCourses?: boolean;
  appContext: AppContext | undefined;
  students: StudentAggregateAnalytics[];
}

export const StudentAnalyticsTable: FC<StudentAnalyticsTableProps> = ({
  students,
  appContext,
  showEnrolledCourses = true,
}) => {
  const [showStudentDetails, setShowStudentDetails] = useState(false);
  const [showStudentDetailsFor, setShowStudentDetailsFor] = useState('');

  return (
    <table className='table table--bordered'>
      <tbody>
        {students.map((student: StudentAggregateAnalytics) => {
          const badAttendance = student.avgAttendance < 60;
          return (
            <tr
              key={student.userId}
              className='hovered clickable'
              onClick={() => {
                setShowStudentDetails(true);
                setShowStudentDetailsFor(student.userId);
              }}
            >
              <td className='table__cell'>
                <div className='table__cell-header table__cell-header--title'>{student.name}</div>
                <div className='table__cell-value'>{student.emailId}</div>
              </td>
              {appContext === 'organization' && showEnrolledCourses && (
                <td className='table__cell table__cell--stats'>
                  <div className='analytics-table__stats'>
                    <img className='analytics-table__icon' src={CoursesIcon} alt='' />
                    <span className='analytics-table__value'>{student.coursesEnrolledIn}</span>
                  </div>
                </td>
              )}
              <td className='table__cell table__cell--stats'>
                <div className='analytics-table__stats'>
                  <img
                    className='analytics-table__icon'
                    src={badAttendance ? AttendanceRedIcon : AttendanceSolidIcon}
                    alt=''
                  />
                  <span
                    className={classNames('analytics-table__value', {
                      'analytics-table__value--red': badAttendance,
                    })}
                  >
                    {student.avgAttendance}%
                  </span>
                </div>
              </td>
              <td className='table__cell table__cell--stats'>
                {!!student.atRisk && (
                  <div className='analytics-table__stats'>
                    <img className='analytics-table__icon' src={AtRiskIcon} alt='' />
                  </div>
                )}
              </td>
              <td className='table__cell table__cell--more'>
                <ChevronRightIcon display='block' />
              </td>
            </tr>
          );
        })}
      </tbody>
      <StudentAnalyticsDetails
        isOpen={showStudentDetails}
        studentId={showStudentDetailsFor}
        onClose={() => setShowStudentDetails(false)}
      />
    </table>
  );
};

const mapStateToProps = (state: RootState) => ({
  appContext: state.getAccess?.context,
});

export default connect(mapStateToProps)(StudentAnalyticsTable);
